export default __webpack_public_path__ + "static/media/drello3.864c39e1.gif";